export const administrationAccountsSiteLocationDetails = {
    template: require('./administration-accounts-site-location-details.html'),
    controller: 'AdministrationAccountsSiteLocationDetailsController'
};
